/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { LoadingPage } from '@components/Loading/LoadingPage';
import { ReactNode, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import { errorToastConfig } from '../../config/constants';
import { OidcProvider } from './OidcContext';

export function OidcContextProvider({ children }: { children: ReactNode }) {
    // Override alerts from oidc-spa to show pretty toasts instead
    useEffect(() => {
        const originalAlert = window.alert;
        window.alert = (message: string) => {
            customAlert(message, originalAlert);
        };

        return () => {
            window.alert = originalAlert;
        };
    }, []);

    return (
        <OidcProvider
            fallback={<LoadingPage />}
            ErrorFallback={({ initializationError }) => (
                <h1 style={{ color: 'red' }}>
                    {initializationError.isAuthServerLikelyDown ? (
                        <>Sorry, our authentication server is currently down. Please try again later.</>
                    ) : (
                        // Debugging: Use initializationError.message for details.
                        // This is an issue on your end and should not be shown to users.
                        <>Unexpected authentication error.</>
                    )}
                </h1>
            )}
        >
            {children}
        </OidcProvider>
    );
}

function customAlert(message: string, originalAlert: (message: string) => void) {
    if (message === 'Authentication is currently unavailable. Please try again later.') {
        toast(<FormattedMessage id={'auth.error.authServerUnavailable'} />, errorToastConfig);
    } else {
        originalAlert(message);
    }
}
